import React from 'react'
import { PageCookie } from '../components/Layout/index'

const CookiePolicy = () => {
  return (
    <PageCookie>
      <iframe
        src='https://homepage.ariston-oneteam.com/it/it/system-showroom/cookie-policy-system-showroom.html'
        title='Cookie POlicy AEN'
      ></iframe>
    </PageCookie>
  )
}
export default CookiePolicy
